import React, { useContext } from "react";
import FormikCheckBox from "../FormikCheckbox/FormikCheckBox";
import FormikDatePicker from "../FormikDatePicker/FormikDatePicker";
import FormikInput from "../FormikInput/FormikInput";
import FormikMultiSelect from "../FormikMultiSelect/FormikMultiSelect";
import FormikRadio from "../FormikRadio/FormikRadio";
import FormikSelect from "../FormikSelect/FormikSelect";
import FormikTextArea from "../FormikTextArea/FormikTextArea";
import FormikControlContext from "../../../Contexts/FormikControlContext";
import ArrayGroupComponent from "../ArrayGroupComponent/ArrayGroupComponent";
import ObjectGroupComponent from "../ObjectGroupComponent/ObjectGroupComponent";
import AutoCompleteField from "../AutoCompleteField/AutoCompleteField";
import { useFormikContext } from "formik";

export default function FormikControl() {
  const field = useContext(FormikControlContext);

  // -----------Start--------------------
  // This all logic is for showing selected option in the field
  // Logic is temporary and should be removed later
  const formik = useFormikContext();
  const { values } = formik;
  // console.log("Formik-Control Values",values)

  const { htmlElement, name } = field;
  const f_name = name?.split(".")[0];
  // ------------End---------------------

  switch (htmlElement.toLowerCase()) {
    case "textfield":
      return <FormikInput />;
    case "select":
      return <FormikSelect />;
    case "datepicker":
      return <FormikDatePicker />;
    case "checkbox":
      return <FormikCheckBox />;
    case "textarea":
      return <FormikTextArea />;
    case "radio":
      return <FormikRadio />;
    case "multiselect":
      return <FormikMultiSelect />;
    case "autocomplete":
      return <AutoCompleteField key={values[f_name].auto_field_key} />;
    case "array":
      return <ArrayGroupComponent inputArray={field} />;
    case "object":
      return <ObjectGroupComponent inputObject={field} />;
    default:
      return null;
  }
}
